import * as React from 'react';
import { Grid, Header, Message } from 'semantic-ui-react';
import { useStore } from '~/Application/Store';
import { ErrorConsumer } from '~/ErrorHandler';
import { Reset } from '~/Password';
import { ErrorAlert } from '~/UI';
export var PasswordReset = function () {
    var _a = React.useState(false), completed = _a[0], setCompleted = _a[1];
    var supportEmail = useStore().config.contact.supportEmail;
    return (<Grid data-testid='reset-password' style={{ height: '100vh' }} textAlign='center' verticalAlign='middle'>
			<Grid.Column style={{ maxWidth: 450 }} textAlign='left'>
				<Header>Požadavek na nové heslo</Header>
				<ErrorConsumer>{function (error) { return <ErrorAlert>{error}</ErrorAlert>; }}</ErrorConsumer>
				{completed ? (<Message success>Žádost o nové heslo byla úspěšně odeslána. Pokračujte instrukcemi obdržené emailem.</Message>) : (<>
						<p>Zadejte váš přihlašovací email. Na tento email vám zašleme odkaz na nastavení nového hesla.</p>
						<Reset contact={supportEmail} onComplete={function () {
                setCompleted(true);
            }}/>
					</>)}
			</Grid.Column>
		</Grid>);
};
PasswordReset.displayName = 'Application.PasswordReset';
